import React from 'react';

const spiner = (props) => {
    return (
       
        <div className="ui active dimmer">
    <div className="ui loader">{props.message}</div>
  </div> 
      
    );
};

export default spiner;